var _circle, _rect, _rect2, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1436,
    cy: 9.58116,
    r: 8.66867,
    stroke: "white",
    strokeWidth: 1.82498
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.0374,
    width: 27.3747,
    height: 9.12492,
    fill: "#323232"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8715,
    y: 6.46119,
    width: 17.8574,
    height: 5.38438,
    fill: "#323232"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.47495,
    cy: 11.4061,
    r: 2.28123,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8123,
    cy: 11.4061,
    r: 2.28123,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.58edbde175da24e1bcbdbfad1b4cf175.svg";
export { ForwardRef as ReactComponent };